import { NgModule } from '@angular/core';
import { ChapterStatusPipe } from './chapters';
import { SafeHtmlPipe } from './safehtml';
import { CheckinFilterPipe } from './checkins';

@NgModule({
	declarations: [
    ChapterStatusPipe,
    SafeHtmlPipe,
    CheckinFilterPipe,
  ],
	imports: [],
	exports: [
    ChapterStatusPipe,
    SafeHtmlPipe,
    CheckinFilterPipe,
  ]
})
export class PipesModule {}
